module.exports = __webpack_public_path__ + "img/overview_behind.764d77fc.png";